import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from '@services/user.service';
import { PageService } from '@services/page.service';
import { HttpUtilService } from '@services/http-util.service';
import { environment } from '@env/environment.prod';
import { NotificationsService } from '@services/notifications.service';
import { TranslationService } from '@services/translation.service';
import { Router } from '@angular/router';
import { MainSidebarService } from '@services/main-sidebar.service';
import { Subject, take, of, catchError } from 'rxjs';
import { timeout } from 'rxjs/operators';

@Component({
  selector: 'app-verify-phone-and-email',
  templateUrl: './verify-phone-and-email.component.html',
  styleUrls: ['./verify-phone-and-email.component.scss'],
  standalone: false,
})
export class VerifyPhoneAndEmailComponent implements OnInit, OnDestroy {
  viewMode = 'VERIFY'; // 'VERIFY' | 'EDIT'

  userInfo;
  verificationCode = {
    email: {
      codeSent: false,
      code: null,
    },
  };

  disableSave = false;

  updatedData = {
    data: {
      email: null,
    },
  };

  cognitoSsoUr$;
  hasSSOEnabled;
  destroy$ = new Subject();
  processingValidation: boolean;
  isRequestingVerification: boolean;
  pageRedirection: boolean;
  constructor(
    private router: Router,
    private userService: UserService,
    private page: PageService,
    private notifications: NotificationsService,
    private httpUtils: HttpUtilService,
    private translationService: TranslationService,
    private mainSidebarService: MainSidebarService
  ) {}

  ngOnInit() {
    this.page.updateHideMenu(true);
    this.userInfo = this.userService.getUserInfo();
    this.updatedData.data = {
      email: this.userInfo.email,
    };
  }

  ngOnDestroy() {
    this.destroy$.next('');
    this.destroy$.complete();
  }

  cancelEdit() {
    this.viewMode = 'VERIFY';
    // Reset values
    this.updatedData.data.email = this.userInfo.email;
  }

  saveNewContact() {
    this.disableSave = true;
    const updates = this.updatedData;
    this.httpUtils
      .request('PUT', environment.apiRoot + '/users/self', updates, null, true)
      .subscribe({
        next: data => {
          if (data?.updated) {
            this.userService.resetUserInfo().subscribe(newInfo => {
              this.userInfo = newInfo;
              this.disableSave = false;
              this.viewMode = 'VERIFY';
              this.notifications.popNotification(
                '',
                this.translationService.getTranslatedContent(
                  'updated_user',
                  'Updated User'
                )
              );
            });
          } else {
            const message = data?.errorMessage
              ? `${this.translationService.getTranslatedContent('error_updating_user', 'Error Updating User')}: ${data.errorMessage}`
              : this.translationService.getTranslatedContent(
                  'uknown_error',
                  'Unknown Error'
                );
            this.notifications.popNotification('', message);
            this.disableSave = false;
          }
        },
        error: () => {
          this.disableSave = false;
        },
      });
  }

  handleVerificationError(contactType, error = 'Uknown Error') {
    const text = this.translationService.getTranslatedContent(
      'error_attempting_to_validate',
      'Error attempting to Validate'
    );
    this.processingValidation = false;

    this.verificationCode[contactType].code = null;
    this.notifications.popNotification('', text + ': ' + error);
  }

  requestVerification(contactType) {
    this.isRequestingVerification = true;
    this.userService.getVerificationCode(contactType).subscribe(
      () => {
        this.verificationCode[contactType].codeSent = true;
        this.isRequestingVerification = false;
      },
      err => {
        this.isRequestingVerification = false;
        console.log(err);
        console.log('Unable to send verification at this time');
        this.notifications.popNotification(
          this.translationService.getTranslatedContent('error', 'Error'),
          'Unable to send verification at this time'
        );
      }
    );
  }

  sendVerificataion(contactType) {
    if (this.processingValidation) return;
    this.processingValidation = true;
    this.userService
      .sendVerficationCode(contactType, this.verificationCode[contactType].code)
      .subscribe(
        data => {
          if (data?.error)
            return this.handleVerificationError(contactType, data?.error);
          this.userInfo[contactType + '_verified'] = true;
          this.processingValidation = false;
          this.userService.setUserInfo(this.userInfo);
          this.verificationCode[contactType].codeSent = false;
          this.verificationCode[contactType].code = null;
          this.userService.getCognitoUserAttributes$(true); //refreshes for all other subscribers of CognitoUserAttributes
        },
        err => {
          this.handleVerificationError(contactType, err?.message);
        }
      );
  }
  postVerifyContinue() {
    const continueAfterSessionReady = () => {
      this.navHome();
    };

    if (this.userService.loggedIn) {
      continueAfterSessionReady();
      return;
    }

    this.userService
      .isLoggedIn()
      .pipe(
        take(1),
        catchError(() => of(false))
      )
      .subscribe(loggedIn => {
        if (loggedIn) {
          continueAfterSessionReady();
          return;
        }
        this.router.navigate(['/login']);
      });
  }

  navHome() {
    this.pageRedirection = true;
    this.mainSidebarService.updateState(true);
    this.userService
      .getRoleDetails(true)
      .pipe(
        take(1),
        timeout(5000),
        catchError(() => of(null))
      )
      .subscribe(() => {
        this.router.navigate(['/home']).then(() => {
          this.userService.checkForMfaEnabled({ force: true });
        });
      });
  }

}
